import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from 'shared/components/avatar/Avatar';
import { connect } from 'react-redux';
import { firstLetters } from 'utils/strings';

class NoteItem extends React.Component {
  render() {
    let { trainer, text } = this.props;
    let name = `${trainer?.first_name} ${trainer?.last_name}`;

    return (
      <div className="note-item">
        <Avatar
          src={trainer?.photo}
          firstLetters={firstLetters(name)}
          width="32"
          height="32"
          name={name}
          text={this.props.lastActive}
        />
        <Link to={`/clients/${this.props.clientId}/notes/${this.props.id}`}>
          <h4>{this.props.title}</h4>
          <p className="note-content">{text}</p>
        </Link>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    trainer: state.trainerProfileReducer.trainer
  };
}

export default connect(mapStateToProps, null)(NoteItem);
